import React from 'react';
/**
 * SVG Definition for full-sized section break.
 */

export var OwnUpDesktopBreak = function OwnUpDesktopBreak() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "1179",
    height: "26",
    viewBox: "0 0 1179 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 20.5591C129.116 4.61222 278.101 -4.65165 412.363 4.80528C558.911 15.1276 697.77 27.307 849.59 24.6232C961.176 22.6504 1066.76 9.73792 1178 6.70917",
    strokeWidth: "2"
  }));
};